import { Action } from 'react-fetching-library';

export const getContactInformation: Action = {
  method: 'GET',
  endpoint: 'items/information/1',
};
